import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import {
  Close as CloseIcon,
  DirectionsCar,
  Group,
  DataUsage,
  ArrowForward,
  DirectionsBus,
} from "@mui/icons-material";

const onboardingSteps = [
  {
    title: "Add Vehicles",
    description: "Add your vehicles and documents",
    icon: <DirectionsBus color="primary" />,
    route: "/vehicles",
  },
  {
    title: "Manage Users",
    description: "Add your team members and assign roles",
    icon: <Group color="primary" />,
    route: "/company-staff",
  },
  {
    title: "Setup Master Data",
    description: "Configure routes, clients, and business data.",
    icon: <DataUsage color="primary" />,
    route: "/master-data",
  },
];

export const HelperPopup = ({
  title,
  description,
  open,
  onClose,
}: {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
}) => {
  const handleStepAction = (route: string) => {
    window.location.href = route;
    onClose();
  };

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ py: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>

        <List dense>
          {onboardingSteps.map((step, index) => (
            <ListItem key={step.title} disablePadding>
              <ListItemButton
                onClick={() => handleStepAction(step.route)}
                sx={{ borderRadius: 1, mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>{step.icon}</ListItemIcon>
                <ListItemText
                  primary={step.title}
                  secondary={step.description}
                  primaryTypographyProps={{
                    fontWeight: 500,
                    fontSize: "0.9rem",
                  }}
                  secondaryTypographyProps={{ fontSize: "0.8rem" }}
                />
                <ArrowForward fontSize="small" color="action" />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="text"
          size="small"
          sx={{ textTransform: "none" }}
        >
          Maybe later
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelperPopup;
